export * from './widget-dialog.component';
